import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import InlineVideo from '../../components/inline-video';
import ResponsiveVideo from '../../components/responsive-video';
import VideoModalButton from '../../components/video-modal-button';
import SingleProductAddToCart from './components/single-product-add-to-cart';
import ScrollEventTracker from './components/scroll-event-tracker';
$(() => {
    VideoModalButton.init();
    RevealWhenVisible.init();
    InlineVideo.init();
    ResponsiveVideo.init();
    SingleProductAddToCart.init();
    ScrollEventTracker.init();
});
